
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { downloadFile } from '../../global/functions/util'
import { Invoice, InvoicePdf } from '../../global/models'

@Component
export default class CustomerInvoiceReadPage extends Vue {
  loading = false

  invoice?: Invoice | null = null

  error: string | null = null

  get hasPdfs() {
    return this.invoice && !!this.invoice.pdfs?.length
  }

  get canDownloadReceipt() {
    return !this.loading && this.hasPdfs
  }

  get invoiceId() {
    return this.$route.params.id
  }

  mounted() {
    this.getInvoice()
  }

  async getInvoice() {
    this.loading = true
    try {
      const result = await axios.get<Invoice>(`invoices/${this.invoiceId}`)
      setTimeout(() => {
        this.loading = false
        this.invoice = result.data
      }, 200)
    } catch (error) {
      this.loading = false
      if (error.response) {
        switch (error.response.status) {
          case 404:
            this.error = 'not-found'
            break
          case 403:
            this.error = 'unauthorised'
            break
          default:
            this.error = 'generic'
        }
      } else {
        this.error = 'generic'
      }
    }
  }

  downloadReceipt() {
    const invoicePdfs = this.invoice?.pdfs || []
    const invoicePdf = invoicePdfs[0]

    if (!invoicePdf) {
      return
    }
    downloadFile(invoicePdf.path)
  }
}
